import { generateRawSelectors } from 'initial-state';
import { initialState } from '../initialState';
import { ISloydStore } from '../types';

// @ts-ignore
export const raw = generateRawSelectors<ISloydStore>(initialState);
